import React, { Component } from "react";
import { connect } from "react-redux";
import PageLayout from "../../components/PageLayout";
import ListMailsEditorControl from "./ListMailsEditorControl";
import Jumbotron from "../../components/Jumbotron";
import NavBar from "../../NavBar/NavBar";
import Throbber from "../../components/Throbber";
import { ensureSite } from "../../../redux/modules/sites/actions";
import {
  loadRecipients,
  updateRecipients,
} from "../../../redux/modules/flightReport/actions";
import { FlightReportState } from "../../../redux/modules/flightReport/reducer";
import assign from "lodash/assign";
import Alert from "../../components/Alert";

import {
  QC_LIST_TYPE,
  GCP_LIST_TYPE,
} from "../../../redux/modules/flightReport/reducer";

import { GlobalState } from "../../../redux/modules/rootReducer";

type SiteFlightReportRecipientsEditPageProps = {
  customerId: string;
  siteId: string;
  flightReport: FlightReportState;
  dispatch: Function;
};

class SiteFlightReportRecipientsEditPage extends Component<
  SiteFlightReportRecipientsEditPageProps
> {
  componentDidMount() {
    const { dispatch, customerId, siteId } = this.props;
    dispatch(ensureSite(customerId, siteId));
    dispatch(loadRecipients(customerId, siteId));
  }

  handleListMailsChange = (type: string, recipients: Array<string>) => {
    const { customerId, siteId, flightReport, dispatch } = this.props;
    const updatedRecipients = assign(flightReport.recipients, {
      [type]: recipients,
    });

    // @ts-ignore
    dispatch(updateRecipients(customerId, siteId, updatedRecipients));
  };

  render() {
    return (
      <PageLayout
        navBar={<NavBar />}
        header={this.renderHeader()}
        content={this.renderContent()}
      />
    );
  }

  renderHeader() {
    return (
      <Jumbotron
        imageUrl={"logo-dashboard-flight-report-recipients.svg"}
        header={"Flight Report Recipients"}
        subheader={null}
      />
    );
  }

  renderContent() {
    const { pending, error, recipients } = this.props.flightReport;

    if (pending) {
      return (
        <div style={{ textAlign: "center" }}>
          <Throbber />
        </div>
      );
    }

    if (error) {
      return <Alert>{error.message}</Alert>;
    }

    const qcUsersEmailsList = recipients[QC_LIST_TYPE] || [];
    const gcpUsersEmailsList = recipients[GCP_LIST_TYPE] || [];
    return (
      <div style={{ width: "100%", height: "100%", display: "flex" }}>
        <ListMailsEditorControl
          labelName="Quality Report"
          inputHintText="Add recipient"
          onChangeList={this.handleListMailsChange.bind(this, QC_LIST_TYPE)}
          dataList={qcUsersEmailsList}
        />
        <ListMailsEditorControl
          labelName="Flight Markers Request"
          inputHintText="Add recipient"
          onChangeList={this.handleListMailsChange.bind(this, GCP_LIST_TYPE)}
          dataList={gcpUsersEmailsList}
        />
      </div>
    );
  }
}

export default connect((state: GlobalState) => {
  return {
    flightReport: state.flightReport,
  };
})(SiteFlightReportRecipientsEditPage);
